<template>
	<v-btn v-if="!panelDisablePopout" variant="flat" @click="onClick">
		<v-icon
			:icon="isPopout ? 'mdi-arrow-collapse' : 'mdi-open-in-new'"
			:color="isPopout ? 'secondary' : 'primary'"
		/>
	</v-btn>
</template>

<script>
import Panels from "@/enums/Panels";

export default {
	name: "RightActionDockview",

	props: {
		params: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			isPopout: this.params.api.location.type === "popout",
			activePanelName: this.params.group.activePanel?.params?.panelName ?? null
		};
	},

	computed: {
		panelDisablePopout() {
			return !!Panels[this.activePanelName]?.disablePopout;
		}
	},

	mounted() {
		// On mount, check the URL to determine if this panel should start as a popout (restores state on page refresh)
		this.isPopout = !!new URLSearchParams(window.location.search).get("panel");

		// Update activePanelName reactively when the active panel changes within this group
		this.params.group.api.onDidActiveChange(() => {
			this.activePanelName = this.params.group.activePanel?.params?.panelName ?? null;
		});

		// Subscribe to Dockview location changes to update isPopout reactively when the panel is moved at runtime
		this.params.group.api.onDidLocationChange(event => {
			this.isPopout = event.location.type === "popout";
		});
	},

	methods: {
		onClick() {
			const panel = this.params.group.activePanel;

			if (this.isPopout) {
				// Remove session storage when closing popout
				sessionStorage.removeItem(`popoutPanel-${panel.id}`);

				this.closeWindow();
			} else {
				// Save the current panel state in sessionStorage so it can be restored if popped out on refresh
				sessionStorage.setItem(
					`popoutPanel-${panel.id}`,
					JSON.stringify({
						id: panel.id,
						component: panel.api.component,
						params: panel.params
					})
				);

				// Open the panel in a pop-out window
				this.params.containerApi.addPopoutGroup(this.params.group, {
					popoutUrl: `?panel=${panel.id}`
				});
			}
		},

		closeWindow() {
			this.params.group.api.getWindow().close();
		}
	}
};
</script>

<style lang="scss" scoped>
button {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 30px;
	height: 100% !important;
	font-size: 18px;
}
</style>
